<script lang="ts" setup>
import { ref, provide, onMounted, onBeforeUnmount, inject } from 'vue';
import PerspectiveList from '@/components/Perspectives/PerspectiveList.vue';
import AddPerspective from '@/components/Perspectives/AddPerspective.vue';
import UpdatePerspective from '@/components/Perspectives/UpdatePerspective.vue';
import PerspectiveControls from '@/components/Perspectives/PerspectiveControls.vue';

import type { Ref } from 'vue';
import type { Viewer, Nullable, Extension } from '@immersive-tech/viewer-engine';
import type { CameraTargetHelper, Perspectives } from '@/viewerExtensions';

const viewer = inject('viewer') as Ref<Nullable<Viewer>>;
const activePerspective = ref<Nullable<string>>(null);
const previewRestrictions = ref(false);
const cameraTargetHelperExtension = viewer.value?.extensions.get('CameraTargetHelper') as Extension<CameraTargetHelper>;
const perspectivesExtension = viewer.value?.extensions.get('Perspectives') as Extension<Perspectives>;

const mountHandler = () => {
  cameraTargetHelperExtension.showHelper();
};

const unmountHandler = () => {
  cameraTargetHelperExtension.hideHelper();
  perspectivesExtension.resetZoomRestriction();
  perspectivesExtension.resetAngleRestriction();
};

provide('activePerspective', activePerspective);
provide('previewRestrictions', previewRestrictions);

onMounted(mountHandler);
onBeforeUnmount(unmountHandler);
</script>

<template>
  <PerspectiveList />
  <UpdatePerspective v-if="activePerspective !== null" />
  <AddPerspective v-if="activePerspective === null" />

  <div class="mt-auto">
    <PerspectiveControls />
  </div>
</template>
